var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-card',{staticClass:"p-0 border-0 bg-transparent h-100"},[_c('variable-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }